import { useNavigate } from "react-router-dom";
import { mutate } from "swr";
import { Button } from "~/components/ui/button";
import useToast from "~/components/ui/toast";
import { ROUTE_NEXTGEN_VIEW } from "~/router/constants";
import { agentListPath, duplicateAgent } from "~/services/agents";

export function useDuplicateAgent() {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();

  return async (agentId: string, displayName: string) => {
    try {
      const duplicate = await duplicateAgent(agentId);
      await mutate(agentListPath());
      showSuccess(
        `"${displayName}" duplicated`,
        undefined,
        <Button
          variant="link"
          size="sm"
          className="h-auto p-0 text-xs font-medium text-green-700 underline-offset-2 hover:text-green-800"
          onClick={() => navigate(`${ROUTE_NEXTGEN_VIEW}/agents/${duplicate.id}/profile`)}
        >
          View duplicate
        </Button>
      );
    } catch {
      showError("Failed to duplicate agent");
    }
  };
}
